import { render, staticRenderFns } from "./popupNew.vue?vue&type=template&id=a36b1680&scoped=true&"
import script from "./popupNew.vue?vue&type=script&lang=js&"
export * from "./popupNew.vue?vue&type=script&lang=js&"
import style0 from "./popupNew.vue?vue&type=style&index=0&id=a36b1680&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36b1680",
  null
  
)

export default component.exports